// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l8P9","option":"styles_option__36_N4","selected":"styles_selected__2lI4k"};